import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberTile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_225_48)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_225_48)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_225_48",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 8,
				width: 32,
				height: 16,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M31.5517 8.22388H0.448242V23.7756H31.5517V8.22388Z",
					fill: "white"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_225_48)",
				children: [/* @__PURE__ */ _jsx("mask", {
					id: "mask1_225_48",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 0,
					y: 8,
					width: 32,
					height: 16,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M31.5517 8.22388H0.448242V23.7756H31.5517V8.22388Z",
						fill: "white"
					})
				}), /* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask1_225_48)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M4.5033 9.98275H4.45923C4.22415 10.1306 1.62362 12.0228 0.448242 12.762V11.2393C0.889009 10.9436 4.07723 8.69663 4.48861 8.44531H5.88438V23.5388H4.51799V9.98275H4.5033Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M14.3014 8.22375C16.9167 8.22375 18.9588 10.0273 18.9588 12.3334C18.9588 13.9891 18.2243 15.2309 15.7266 17.8327L11.554 22.2233V22.2676H19.3408V23.539H9.57051V22.5337L14.8597 16.9014C17.0048 14.6396 17.5337 13.7378 17.5337 12.4221C17.5337 10.7664 16.0792 9.48031 14.2427 9.48031C12.4061 9.48031 10.8781 10.8551 10.8634 12.6882H9.49707C9.51176 10.116 11.554 8.22375 14.2867 8.22375H14.3014Z",
							fill: "currentColor"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M24.4266 15.1422H26.175C28.1291 15.1422 29.4808 13.93 29.4808 12.2448C29.4808 10.5595 28.2614 9.46554 26.2338 9.46554C24.3826 9.46554 23.0602 10.589 22.8987 12.2595H21.5323C21.7086 9.83512 23.6039 8.20898 26.2926 8.20898C28.9812 8.20898 30.9059 9.82033 30.9059 12.0674C30.9059 13.9596 29.6865 15.3196 27.7765 15.6596V15.704C30.0685 15.837 31.5377 17.271 31.5377 19.3997C31.5377 21.9424 29.2751 23.7607 26.3513 23.7607C23.4276 23.7607 21.2825 22.0311 21.1943 19.6215H22.5607C22.6783 21.3068 24.1769 22.5189 26.3366 22.5189C28.4964 22.5189 30.0831 21.2328 30.0831 19.4441C30.0831 17.5223 28.6139 16.3544 26.2044 16.3544H24.3973V15.1422H24.4266Z",
							fill: "currentColor"
						})
					]
				})]
			})]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_225_48",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_225_48",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 15.7377,
			fill: "white",
			transform: "translate(0 8.1311)"
		})
	})] })]
});
export default SvgNumberTile;
